import { PageHeader } from "@/components/site/PageHeader";
import { PersonalStory } from "@/components/sections/PersonalStory";
import { IMAGES } from "@/lib/content";

export default function About() {
  return (
    <>
      <PageHeader label="About" title="WHY I'M BUILDING THIS" image={IMAGES.creator} />
      <PersonalStory showLabel={false} />
    </>
  );
}
